"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sentryInitializer;
var Sentry = _interopRequireWildcard(require("@sentry/react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function eventContainsPreloadFrame(event) {
  var _event$exception;
  var values = (event === null || event === void 0 || (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values) || [];
  return values.some(function (value) {
    var _value$stacktrace;
    return (((_value$stacktrace = value.stacktrace) === null || _value$stacktrace === void 0 ? void 0 : _value$stacktrace.frames) || []).some(function (frame) {
      var frameText = [frame.filename, frame.abs_path, frame.context_line, frame.pre_context && frame.pre_context.join('\n'), frame.post_context && frame.post_context.join('\n')].filter(Boolean).join('\n');
      return frameText.includes('preload-helper') || frameText.includes('modulepreload') || frameText.includes('type="module" crossorigin');
    });
  });
}
function isRecoverableAssetLoadError(messageStr, event) {
  return messageStr.includes('ChunkLoadError') || messageStr.includes('CSS_CHUNK_LOAD_FAILED') || messageStr.includes('Loading CSS chunk') && messageStr.includes('failed') || messageStr.includes('Unable to preload CSS for') || messageStr.includes('Failed to fetch dynamically imported module') || messageStr.includes('Failed to fetch') && eventContainsPreloadFrame(event);
}

// Chrome and the Google app on iOS inject scripts into the page that WebKit attributes to the
// document URL, so their stack overflows have no frames from our JS bundles.
function eventHasOnlyInlineFrames(event) {
  var _event$exception2;
  var frames = ((event === null || event === void 0 || (_event$exception2 = event.exception) === null || _event$exception2 === void 0 ? void 0 : _event$exception2.values) || []).flatMap(function (value) {
    var _value$stacktrace2;
    return ((_value$stacktrace2 = value.stacktrace) === null || _value$stacktrace2 === void 0 ? void 0 : _value$stacktrace2.frames) || [];
  });
  return frames.length > 0 && frames.every(function (frame) {
    var path = (frame.abs_path || frame.filename || '').split(/[?#]/)[0];
    return !path.endsWith('.js');
  });
}
function isLowSignalBrowserError(messageStr, event) {
  return messageStr.includes('Maximum call stack') && (eventContainsPreloadFrame(event) || eventHasOnlyInlineFrames(event));
}
function sentryInitializer() {
  // need to disable uBlock Origin on localhost if testing error tracking
  Sentry.init({
    dsn: 'https://019e707473e54ce39a35d78e8ed2cd6b@o85774.ingest.sentry.io/186663',
    // CRITICAL: release must match the release used when uploading source maps
    // This is set during build via REACT_APP_SENTRY_RELEASE env var
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_GIT_SHA,
    environment: process.env.NODE_ENV,
    ignoreErrors: ['AbortError', 'NotSupportedError', 'NotAllowedError', "Can't find variable: EmptyRanges", 'invalid origin', 'Request timeout for contentScriptVisibilityChanged', /Unhandled error response received for message <.*>/, 'Not implemented on this platform'],
    denyUrls: [/webkit-masked-url/],
    // Capture more context for debugging
    normalizeDepth: 5,
    beforeSend: function beforeSend(event, hint) {
      var isDevelopment = process.env.NODE_ENV === 'development';
      var isLocalhost = window && window.location && window.location.href.match('localhost');
      var isNgrok = window && window.location && window.location.href.match('ngrok');
      if (isDevelopment || isLocalhost || isNgrok) {
        return null; // this is equal to shouldSend false
      }
      var originalException = hint && hint.originalException;
      var originalMessage = originalException && (originalException.message || originalException);
      if (originalMessage) {
        var messageStr = String(originalMessage);
        if (isLowSignalBrowserError(messageStr, event)) {
          return null;
        }
        var isResizeObserverError = messageStr.includes('ResizeObserver loop') || messageStr.includes('ResizeObserver loop limit exceeded');
        if (isResizeObserverError) {
          return null;
        }
        var isChunkError = isRecoverableAssetLoadError(messageStr, event);
        if (isChunkError && typeof window !== 'undefined' && window.sessionStorage) {
          var key = 'seedlang__chunk_reload_attempted_v1';
          var lastAttempt = window.sessionStorage.getItem(key);
          if (!lastAttempt) return null;
          if (Date.now() - parseInt(lastAttempt, 10) < 2000) return null;
        }
      }

      // Add extra context for stack overflow errors
      if (originalMessage && String(originalMessage).includes('Maximum call stack')) {
        event.tags = event.tags || {};
        event.tags.error_type = 'stack_overflow';
        event.extra = event.extra || {};
        event.extra.url = window && window.location && window.location.href;
        event.extra.userAgent = window && window.navigator && window.navigator.userAgent;
      }
      return event;
    }
  });
}